package com.example.mystybag.common.model

import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import com.example.mystybag.core.defines.TextFieldType
import dev.icerock.moko.resources.ImageResource

data class TextInputBottomSheetUIState (
    val text            : TextFieldValue            = TextFieldValue(),
    val title           : String                    = "",
    val hint            : String                    = "",
    val isError         : Boolean                   = false,
    val errorText       : String                    = "",
    val inputType       : TextFieldType?            = null,
    val focusTextField  : Boolean                   = false,
    val imageResource   : ImageResource?            = null,
    val buttonText      : String                    = "",
    val capitalization  : KeyboardCapitalization    = KeyboardCapitalization.Unspecified,
    val keyboardType    : KeyboardType              = KeyboardType.Unspecified,
    val autoCorrect     : Boolean?                  = null,
    val prefix          : String?                   = null,
    val suffix          : String?                   = null,
    val infoPromptText  : String?                   = null
)